//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    padding: 45px 30px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
    width: 800px;
    & > *:first-child {
        align-self: center;
    }
    @media (max-width: 1100px) {
        width: 100%;
    }
`;

export const ListTime = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 25px;
    list-style: none;
    margin: 0;
    padding: 10px 0;
    padding-right: 10px;
    margin-top: 5px;
    height: 290px;
    overflow-y: scroll;
    ::-webkit-scrollbar {
        width: 6px;
        @media (min-width: 700px) {
            width: 7px;
        }
    }

`;
export const StyledListTimeItem = styled.li`
    display: flex;
    flex-wrap: wrap;
    align-items: ${({ align }) => align};
    gap: 10px;
`;